/*
 * Variant image filtering for multi-image-variant products.
 *
 * Each product image is tagged (via alt text) with the color it belongs to.
 * When a color is selected we show that color's images plus any "shared"
 * images — images whose alt text contains none of the product's colors
 * (e.g. a lifestyle shot that applies to every color). Everything else is
 * hidden.
 *
 * This only filters the list of images; Dawn's media-gallery.js still drives
 * the carousel/thumbnails/zoom. The one extra step is re-pointing the active
 * slide on color change, because this theme's product-info.js no longer does
 * Dawn's native variant -> media swap.
 */
document.addEventListener('DOMContentLoaded', function () {
  const variantInputs = document.querySelectorAll('.color-variant-input, .morph-variant-input');
  if (!variantInputs.length) return;

  const gallery = document.querySelector('media-gallery');
  const layout = (gallery && gallery.dataset.desktopLayout) || '';
  const isCarousel = layout.indexOf('thumbnail') !== -1;
  // In the carousel we clear the inline display so the slider CSS governs which
  // single image is visible; in stacked layouts we set an explicit value so all
  // matching images render.
  const showValue = isCarousel ? '' : 'block';

  function formatValue(str) {
    return (str || '').toLowerCase().replace(/'/g, '').replace(/\s+/g, '-');
  }

  // All color option values, used to decide whether an image is "shared".
  const allColors = [];
  document.querySelectorAll('.color-variant-input').forEach(function (input) {
    const value = formatValue(input.value);
    if (value && allColors.indexOf(value) === -1) allColors.push(value);
  });

  function selectedValue() {
    let color = '';
    let morph = '';
    variantInputs.forEach(function (input) {
      if (!input.checked) return;
      if (input.classList.contains('morph-variant-input')) {
        morph = formatValue(input.value);
      } else {
        color = formatValue(input.value);
      }
    });
    return morph ? morph + '-' + color : color;
  }

  function altFor(item) {
    const img = item.querySelector('img');
    return formatValue(img ? img.getAttribute('alt') : '');
  }

  function isColorMatched(alt, selected) {
    return selected !== '' && alt.indexOf(selected) !== -1;
  }

  function isShared(alt) {
    // Shared when the alt text references none of the product's colors.
    return !allColors.some(function (color) {
      return alt.indexOf(color) !== -1;
    });
  }

  function isVisible(alt, selected) {
    if (selected === '') return true;
    return isColorMatched(alt, selected) || isShared(alt);
  }

  function apply(items, selected) {
    items.forEach(function (item) {
      item.style.display = isVisible(altFor(item), selected) ? showValue : 'none';
    });
  }

  function updateImages() {
    const selected = selectedValue();
    const mediaItems = document.querySelectorAll('.product__media-item');
    const thumbItems = document.querySelectorAll('.thumbnail-list__item');

    apply(mediaItems, selected);
    apply(thumbItems, selected);

    // Keep the zoom modal in sync (its images aren't wrapped in media items).
    document.querySelectorAll('.product-media-modal__content img').forEach(function (img) {
      img.style.display = isVisible(formatValue(img.getAttribute('alt')), selected) ? '' : 'none';
    });

    if (!isCarousel) return;

    // Keep the active slide on a color-matched image (fall back to the first
    // visible one) by triggering Dawn's own thumbnail activation.
    const active = document.querySelector('.product__media-item.is-active');
    const activeValid =
      active && active.style.display !== 'none' && isColorMatched(altFor(active), selected);
    if (activeValid) return;

    let target = Array.prototype.find.call(thumbItems, function (item) {
      return item.style.display !== 'none' && isColorMatched(altFor(item), selected);
    });
    if (!target) {
      target = Array.prototype.find.call(thumbItems, function (item) {
        return item.style.display !== 'none';
      });
    }
    const button = target && target.querySelector('button');
    if (button) button.click();
  }

  variantInputs.forEach(function (input) {
    input.addEventListener('change', updateImages);
  });

  updateImages();
});
